import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core';

@Directive({
    selector: '[appInfiniteScroll]',
})
export class InfiniteScrollDirective {
    @Input() scrollThreshold: number = 300;
    @Output() scrolled = new EventEmitter<void>();
    private previousScrollTop = 0;
    private debounceTimeout: any;

    constructor(private el: ElementRef) {}

    @HostListener('scroll', ['$event'])
    onScroll(): void {
        const { scrollTop, scrollHeight, clientHeight } = this.el.nativeElement;

        // Check if scrolling down and if we're near the bottom
        if (
            scrollTop > this.previousScrollTop &&
            scrollHeight - scrollTop <= clientHeight + this.scrollThreshold
        ) {
            // Debounce to prevent multiple calls in a short time
            if (!this.debounceTimeout) {
                this.debounceTimeout = setTimeout(() => {
                    this.scrolled.emit();
                    this.debounceTimeout = null;
                }, 200); // Adjust the debounce delay as needed
            }
        }

        // Update the previous scroll position
        this.previousScrollTop = scrollTop;
    }
}
